import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { CheckoutParam } from 'src/app/interfaces/stripe';
import { Item } from 'src/app/interfaces/transaction';
import { TransactionType } from 'src/app/types/transaction';
import { DeviceService } from '../../device/device.service';
import { ErrorService } from '../../general/error.service';
import { LanguageService } from '../../general/language.service';
import { TimezoneService } from '../../general/timezone.service';
import { LocalityService } from '../../location/locality.service';

@Injectable({
  providedIn: 'root'


})
export class StripeMetaService implements OnInit, OnDestroy {

  constructor(
    private fns: AngularFireFunctions,
    private deviceService: DeviceService,
    private localityService: LocalityService,
    private languageService: LanguageService,
    private timezoneService: TimezoneService,
    private errorService: ErrorService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  async stripeRetrieveCheckoutParamCall(debugMode: boolean, currency: string, sessionId: string, customerId: string) {
    if (currency && sessionId) {
      return await this.fns.httpsCallable('stripeRetrieveCheckoutParamCall')({
        debugMode,
        currency,
        sessionId,
        customerId,
      }).toPromise().then(async (sessionMeta: any) => {
        return sessionMeta;
      }).catch((err: any) => {
        this.errorService.logError(err);
        return null;
      });
    } else {
      return null;
    }
  }

  setupCheckoutParam(
    transactionType: TransactionType,
    uid: string,
    uuid: string,
    stripeKey: string,
    customerName: string,
    itemList: Item[],
    totalQty: number,
    debugMode: boolean,
    upgrade: boolean,
    trial: boolean,
    gift: boolean,
    bulk: boolean,
    referralCode: string,
    voucherId: string,
    accountId: string,
  ) {
    const checkoutParam: CheckoutParam = {
      uid,
      uuid,
      stripeKey,
      customerName,
      itemList,
      totalQty,
      debugMode,
      upgrade,
      trial,
      gift,
      bulk,
      referralCode,
      voucherId,
      transactionType,
      accountId,
      language: this.languageService.getUserLanguage().code,
      locality: this.localityService.getUserLocality(),
      platform: this.deviceService.deviceInfo.platform,
      timezone: this.timezoneService.getUserTimezone(),
    };
    return checkoutParam;
  }

}
